<!------------ START TEMPLATE ------------>
<template>
  <div>
    <!------------ START FORM ------------>
    <vs-card class="mb-6">
      <form role="form" @submit.stop.prevent="buscar">
        <!-----============================ OBS: No status deve ter um campo SELECT que irá trazer as opções criadas pelo usuário na parte cadastro de Status do Menu USUARIO  ==================------->
        <div class="flex flex-wrap">
          <div class="vx-row w-full">
            <div class="vx-col sm:w-1/4 w-full">
              <span>Data Inicial</span>

              <datepicker
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                v-model="formFiltro.dataInicial"
              ></datepicker>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span>Data Final</span>
              <datepicker
                :format="'dd/MM/yyyy'"
                placeholder="DD/MM/YYYY"
                v-model="formFiltro.dataFinal"
              ></datepicker>
            </div>

            <div
              class="vx-col sm:w-1/4 w-full"
              v-if="filtroAvancado == true && leituraCarteiraGeral == true"
            >
              <span>Divisão</span>
              <v-select
                :options="divisoes"
                name="Divisao"
                id="Divisao"
                v-model="formFiltro.divisoes"
                :state="validateState('Divisao')"
                :class="validateClass('Divisao')"
                @input="filtraRegionaisPorDivisao"
              ></v-select>
            </div>

            <div class="vx-col sm:w-1/4 w-full" v-if="filtroAvancado == true">
              <span>Regional</span>
              <v-select
                :options="regionais"
                name="Regional"
                id="Regional"
                multiple
                v-model="formFiltro.regional"
                @input="filtraConsultoresPorRegional"
                :state="validateState('Regional')"
                :class="validateClass('Regional')"
              ></v-select>
            </div>
          </div>

          <div v-if="filtroAvancado == true" class="vx-row w-full mb-5">
            <div
              v-if="
                $can('Leitura Carteira Regional', 'Associados') ||
                $can('Leitura Carteira Completa', 'Associados')
              "
              class="vx-col sm:w-1/4 w-full"
            >
              <span>Consultor</span>
              <v-select
                :options="consultores"
                name="Consultor"
                id="Consultor"
                multiple
                v-model="formFiltro.consultor"
                :state="validateState('Consultor')"
                :class="validateClass('Consultor')"
              ></v-select>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span>Grupo</span>
              <v-select
                :options="grupos"
                name="Grupos"
                id="Grupos"
                multiple
                v-model="formFiltro.idGrupo"
                :state="validateState('Grupo')"
                :class="validateClass('Grupo')"
              ></v-select>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span>Estado</span>
              <v-select
                :options="estados"
                name="Estado"
                id="Estado"
                v-model="estado"
                @selected="buscaDadosSelectsCidades"
                :state="validateState('Estado')"
                :class="validateClass('Estado')"
              ></v-select>
            </div>

            <div class="vx-col sm:w-1/4 w-full">
              <span>Cidade</span>
              <v-select
                :options="cidades"
                name="Cidade"
                id="Cidade"
                multiple
                v-model="formFiltro.cidade"
                :state="validateState('Cidade')"
                :class="validateClass('Cidade')"
              ></v-select>
            </div>
          </div>
        </div>
      </form>

      <div slot="footer" style="margin-top: -3%">
        <br style="clear: both" />
        <vs-row vs-justify="flex-end" class="flex gap-2">
          <!-- <div class=""> -->
          <vs-button
            @click="buscaFiltrosAvancados()"
            type="gradient"
            color="dark"
            icon-pack="feather"
            icon="icon-sliders"
          ></vs-button>
          <!-- </div> -->

          <vs-button
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            @click="buscar"
            >Buscar</vs-button
          >
        </vs-row>
      </div>
    </vs-card>
    <!------------ END FORM ------------>
  </div>
</template>
<!------------ END TEMPLATE ------------>

<!------------ START SCRIPT ------------>
<script>
import locale from './../../locale';
import Datepicker from 'vuejs-datepicker';
import * as lang from 'vuejs-datepicker/src/locale';
import jwt from 'jsonwebtoken';
import vSelect from 'vue-select';
import service from '../../services';
import ability from '../../services/ability';

export default {
  props: {
    sideBar: {
      type: Boolean,
    },
    dados: {
      type: Object,
    },
    vistoria: {
      type: Boolean,
    },
  },
  watch: {
    estado(value) {
      this.formFiltro.estado = value;
      this.formFiltro.cidade = null;
      this.buscaDadosSelectsCidades(
        'domMunicipio',
        'cidades',
        'nomeCidade',
        'idCidade',
      );
    },
  },
  data() {
    return {
      decoded: null,
      aguardeCadastro: false,
      idEmpresa: null,
      estados: [],
      cidades: [],
      grupos: [],
      regionais: [],
      regionaisUsuario: [],
      idsRegionaisUsuario: [],
      usuarios: [],
      consultores: [],
      status: [],
      regionalDefault: [],
      languages: lang,
      filtroAvancado: false,
      tiposDatas: ['Data Cadastro', 'Data Vistoria'],
      estado: null,
      funcoesValicao: null,
      usuarios_regionais: [],
      id_usuario: '',
      formFiltro: {
        idEmpresa: null,
        placa: null,
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        idGrupo: null,
        cidade: '',
        estado: '',
        tipoData: 'Data Cadastro',
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idProposta: null,
        divisoes: [],
        divisaoPadrao: null,
      },
      resultBuscaDivisoes: null,
      divisoes: [],
      divisaoPadrao: null,
      optionsDivisoes: [],
      leituraCarteiraGeral: false,
      regionaisAux: null,
      resultBuscaDadosConsultores: null,
      consultoresAux: null,
    };
  },
  methods: {
    limparFiltro() {
      this.formFiltro = {
        placa: null,
        nomeAssociado: null,
        consultor: null,
        regional: null,
        status: null,
        idGrupo: null,
        cidade: '',
        estado: '',
        tipoData: 'Data Cadastro',
        dataInicial: this.dataInicio(),
        dataFinal: new Date(),
        idProposta: null,
      };
      this.buscar();
    },
    dataInicio() {
      var date = new Date();
      var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
      var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      return primeiroDia;
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    async buscaDadosSelects(model, array, campoDescricao, campoPK) {
      try {
        const res = await service.getAll('g', {}, `${model}/list/`);
        res.data.forEach((element) => {
          if (array == 'status' && this.vistoria == true) {
            if (
              element[campoPK] == 3 ||
              element[campoPK] == 4 ||
              element[campoPK] == 5 ||
              element[campoPK] == 7
            )
              this[array].push({
                id: element[campoPK],
                label: element[campoDescricao],
              });
          } else
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Falha ao busca dados ${error}`,
          color: 'danger',
          time: 3000,
        });
      }
    },
    async buscaDadosGrupos() {
      try {
        const res = await service.getAll('Grupo', {}, `list/${this.idEmpresa}`);
        res.data.forEach((element) => {
          this.grupos.push({
            id: element.idGrupo,
            label: element.nomeGrupo,
          });
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Falha ao busca dados dos grupos`,
          color: 'danger',
          time: 3000,
        });
      }
    },
    buscaDadosRegionais() {
      this.usuarios.forEach((element) => {
        if (element.idUsuario == this.id_usuario) {
          if (element.usuarios_regionais.length > 0) {
            this.usuarios_regionais = element.usuarios_regionais;

            this.usuarios_regionais.forEach((elementSel) => {
              this.regionaisUsuario.push({
                id: elementSel.id_regional,
                label: elementSel.nome,
              });
            });

            this.regionais = this.regionaisUsuario.concat(this.regionalDefault);
            this.idRegionais = this.regionais.map((item) => item.id);
            this.regional = this.idRegionais;
          } else {
            var usuarios_regionais = element.Usuarios_Regional;
            this.regionais.push({
              id: usuarios_regionais.idRegional,
              label: usuarios_regionais.nome,
            });

            this.idRegionais = this.regionais.map((item) => item.id);
            this.regional = this.idRegionais;
          }
        }
        this.regionaisAux = this.regionais;
      });
    },
    async buscaDadosRegionalDefault(model, array, campoDescricao, campoPK) {
      try {
        const _idEmpresa = this.idEmpresa || this.decoded.id_empresa;

        const res = await service.getAll(
          'g',
          {},
          `${model}/list/idEmpresa/${_idEmpresa}`,
        );

        res.data.forEach((element) => {
          if (element[campoPK] == this.decoded.id_regional) {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          }
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Falha ao busca a regional padrão do usuário`,
          color: 'danger',
          time: 3000,
        });
      }
    },
    async getDecoded() {
      const token = localStorage.getItem('user-token');

      if (token) {
        const _decoded = jwt.decode(token);

        this.idEmpresa = _decoded.id_empresa;

        this.idRegionalPadrao = _decoded.hasOwnProperty('id_regional')
          ? _decoded.id_regional
          : null;

        const _idsRegionaisUsuario = _decoded.hasOwnProperty('regionais')
          ? _decoded.regionais
          : [];

        this.idsRegionaisUsuario = _idsRegionaisUsuario
          .filter(({ id_regional }) => id_regional)
          .map(({ id_regional }) => id_regional);

        const temReginalPadrao = this.idsRegionaisUsuario.includes(
          this.idRegionalPadrao,
        );

        if (!temReginalPadrao) {
          this.idsRegionaisUsuario.push(this.idRegionalPadrao);
        }

        this.decoded = _decoded;
      }
      this.id_usuario = this.decoded.id_usuario;
    },
    async buscaDadosConsultor() {
      try {
        this.usuarios = [];

        const res = await service.getAll(
          'Usuario',
          {},
          'list/' + this.idEmpresa,
        );

        this.resultBuscaDadosConsultores = res.data;

        res.data.forEach((element) => {
          this.usuarios.push(element);
          const { idUsuario, nome } = element;

          const usuarioPerteceRegional = this.idsRegionaisUsuario.includes(
            element.idRegional,
          );

          if (usuarioPerteceRegional) {
            this.consultores.push({
              id: idUsuario,
              label: nome,
            });
          }
        });

        this.consultoresAux = this.consultores;
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Falha ao busca dados dos consultores ${error}`,
          color: 'danger',
          time: 3000,
        });
      }
    },
    async buscaDadosSelectsCidades(model, array, campoDescricao, campoPK) {
      try {
        if (this.formFiltro.estado) {
          this.$vs.loading();
          this[array] = [];
          const res = await service.getAll(
            'g',
            {},
            `${model}/list/codUf/${this.formFiltro.estado.id}`,
          );

          res.data.forEach((element) => {
            this[array].push({
              id: element[campoPK],
              label: element[campoDescricao],
            });
          });

          this.$vs.loading.close();
        } else {
          this[array] = [];
        };
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Falha ao buscar cidades`,
          color: 'danger',
          time: 3000,
        });
      }
    },
    buscar() {
      this.formFiltro.idEmpresa = this.idEmpresa;
      this.$emit('filtro', this.formFiltro);
    },
    async buscaDivisoes() {
      try {
        const permissoes = ability.getPermission().$;
        const _leituraCarteiraGeral = permissoes.filter(
          (permissao) =>
            permissao.subject == 'Cotações' &&
            permissao.action == 'Leitura Carteira Completa',
        );

        const isCarteiraGeral = _leituraCarteiraGeral.length > 0 ? true : false;
        this.leituraCarteiraGeral = isCarteiraGeral;

        if (isCarteiraGeral) {
          const res = await service.getAll(
            'Divisao',
            {},
            `list/${this.idEmpresa}`,
          );

          this.resultBuscaDivisoes = res.data;
          let _divisao = {};

          // filtra a regional padrão
          res.data.forEach((divisao) => {
            divisao.Divisoes_Regionais.forEach((item) => {
              if (item.idRegional == this.idRegionalPadrao) {
                _divisao = {
                  id: divisao.idDivisao,
                  label: divisao.nomeDivisao,
                };
              }
            });
          });

          this.divisaoPadrao = _divisao;
          this.formFiltro.divisaoPadrao = _divisao;

          const _divisoes = res.data.reduce((acc, item) => {
            const { idDivisao, nomeDivisao, Divisoes_Regionais } = item;
            let podeAcessarDivisao = false;

            const _idsRegionaisPorDivisao = Divisoes_Regionais.map(
              (item) => item.idRegional,
            );

            _idsRegionaisPorDivisao.forEach((id) => {
              podeAcessarDivisao = this.idsRegionaisUsuario.includes(id);

              // verifica se a divisao já foi adicionada
              const divisaoAdicionada = acc.filter(
                (item) => item.id == idDivisao,
              );

              const adicionarDivisao = divisaoAdicionada.length;

              if (podeAcessarDivisao && !adicionarDivisao) {
                acc.push({ id: idDivisao, label: nomeDivisao });
              }
            });

            return acc;
          }, []);

          this.divisoes = _divisoes;
        }
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Atenção',
          text: `Falha ao busca as divisões`,
          color: 'danger',
          time: 3000,
        });
      }
    },
    filtraRegionaisPorDivisao() {
      console.log(567, this.formFiltro.divisoes);
      const _divisoes = [this.formFiltro.divisoes];

      const divisaoSelecionada = this.formFiltro.divisoes.id;
      console.log(568, divisaoSelecionada);

      if (!divisaoSelecionada) {
        this.regionais = this.regionaisAux;

        return;
      }

      if (divisaoSelecionada && this.leituraCarteiraGeral) {
        this.formFiltro.regional = [];

        const regionaisPorDivisao = _divisoes.reduce((acc, divisao) => {
          const { id } = divisao;

          const _divisao = this.resultBuscaDivisoes.find(
            (divisao) => divisao.idDivisao == id,
          );

          const { Divisoes_Regionais } = _divisao;

          Divisoes_Regionais.forEach((regional) => {
            acc.push({
              id: regional.idRegional,
              label: regional.regional.nome,
            });
          });

          return acc;
        }, []);

        this.regionais = regionaisPorDivisao;
      }
      return;
    },

    filtraConsultoresPorRegional() {
      const temRegionaisSelecionadas = this.formFiltro.regional.length;

      if (!temRegionaisSelecionadas) {
        this.consultores = this.consultoresAux;

        return;
      }

      if (temRegionaisSelecionadas) {
        const idsRegionaisSelecionadas = this.formFiltro.regional.map(
          (reginal) => reginal.id,
        );

        const consultoresRegional = this.resultBuscaDadosConsultores.reduce(
          (acc, item) => {
            const { idUsuario, nome, idRegional, usuarios_regionais } = item;
            console.log(622, idUsuario, nome, idRegional, usuarios_regionais);

            let idsRegionaisConsultor = usuarios_regionais.map(
              (item) => item.id_regional,
            );

            idsRegionaisConsultor.push(idRegional);

            idsRegionaisConsultor.forEach((item) => {
              const perteceRegional = idsRegionaisSelecionadas.includes(item);

              if (perteceRegional) {
                console.log(632, 'adicionou!!!', {
                  id: idUsuario,
                  label: nome,
                });

                const _consultor = {
                  id: idUsuario,
                  label: nome,
                };
                let temConsultorArray = acc.find(
                  (itemConsultor) => itemConsultor.id == _consultor.id,
                );

                if (temConsultorArray && !temConsultorArray.id) {
                  acc.push({ id: idUsuario, label: nome });
                  temConsultorArray = null;
                }
              }
            });

            return acc;
          },
          [],
        );

        console.log(646, 'consultoresRegional', consultoresRegional.length);
        this.consultores = consultoresRegional;
      }
    },
    async buscaFiltrosAvancados() {
      if (!this.filtroAvancado) {
        await this.$vs.loading();
        this.filtroAvancado = true;

        if (this.grupos.length == 0) {
          await this.buscaDivisoes();
          await this.buscaDadosGrupos();

          await this.buscaDadosSelects(
            'domUf',
            'estados',
            'nomeUf',
            'codUf'
          );

          await this.buscaDadosFiltros();

          await this.buscaDadosSelects(
            'domStatusCotacao',
            'status',
            'nomeStatus',
            'idStatus',
          );
        };

        await this.$vs.loading.close();
      } else this.filtroAvancado = false;
    },

    async buscaDadosFiltros() {
      try {
        this.$vs.loading();

        await service.post('cotacao', 'busca-filtros-consultores-regionais', this.decoded)
        .then(({ data }) => {
          data.regionais.forEach((element) => {
            this.regionais.push({
              id: element.idRegional,
              label: element.nome
            });
          });

          data.consultores.forEach((element) => {
            this.consultores.push({
              id: element.idRegional,
              label: element.nome
            });
          });
        });
      } catch (error) {
        this.$vs.notify({
          position: 'top-center',
          title: 'Falha ao buscar filtros',
          text: error,
          color: 'danger',
        });
      } finally {
        this.$vs.loading.close();
      };
    }
  },
  async created() {
    await this.getDecoded();

    this.$validator.localize('ptBr', locale);
  },
  components: {
    Datepicker,
    'v-select': vSelect
  },
};
</script>
<!------------ END SCRIPT ------------>
<style>
.vs__dropdown-toggle {
  padding: 4px 0 6px 0 !important;
}

.vdp-datepicker input {
  width: 100%;
}

.vdp-datepicker__calendar {
  z-index: 900 !important;
}
</style>
